import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import JsonLd from "./JsonLd";
import { useLang } from "../i18n/LanguageContext";
import { FAQ_I18N } from "../data/faqData";

export default function FAQ() {
  const { lang } = useLang();
  const data = FAQ_I18N[lang] || FAQ_I18N.en || FAQ_I18N.de;
  const faqs = data.items;
  return (
    <section id="faq" className="py-20 bg-slate-50" data-testid="faq-section">
      <JsonLd data={{
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
      }} />
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <div className="text-center mb-10">
          <span className="text-xs uppercase tracking-[0.25em] text-[#F5B400] font-semibold">FAQ</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-black">{data.title}</h2>
          <p className="mt-3 text-slate-500 text-lg">{data.sub}</p>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`}
              className="rounded-2xl border border-slate-100 bg-white px-5 shadow-sm">
              <AccordionTrigger className="text-left font-semibold text-black hover:no-underline py-5">{f.q}</AccordionTrigger>
              <AccordionContent className="text-slate-500 text-base leading-relaxed pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
